import { isBookingPendingConfirmation } from '../helpers/status';
import { BookingRequest } from '../interfaces';
import { useBookingStatus } from './use-booking-status.hook';

export function useIsBookingPendingConfirmation(
  bookingRequest: BookingRequest
) {
  const bookingStatus = useBookingStatus({
    bookingId: bookingRequest.bookingId,
    hotelReferenceId: bookingRequest.hotelSlug,
  });

  return bookingStatus?.status
    ? isBookingPendingConfirmation(bookingStatus.status)
    : false;
}
